<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
};
</script>

<template>
  <content-loader
    width="1329"
    height="104"
    viewBox="15 0 1329 84"
    :speed="2"
    primaryColor="#F9FAFF"
    secondaryColor="#D8DFF6"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <rect x="29" y="26" width="398" height="51" rx="4" />
    <rect x="779" y="22" width="216" height="51" rx="4" />
    <rect x="1005" y="22" width="128" height="54" rx="4" />
    <rect x="1144" y="22" width="128" height="54" rx="4" />
  </content-loader>
</template>
